export var ImageSize = function (image) {
    var myImage = new Image();
    myImage.src = image;
    console.log('ID', image);
    console.log('WIDTH', myImage.width);
    console.log('Height', myImage.height);
    return { width: myImage.width, height: myImage.height };
};



//////////////////
// WEBPACK FOOTER
// ./src/components/post/postUtility.ts
// module id = 1309
// module chunks = 0 1 2 3 4 5 6 7